import { BaseComponent } from '../../components/base-component'
import { delay, $el, transitionToPromise } from '../../utils/utils'
import type { QuantityComponent } from '../../components/quantity-input/quantity'

const CHECKMARK_SELECTOR = `[data-cart-item-checkmark]`
const TOTALS_SELECTOR = `[data-cart-item-totals]`
const QUANTITY_SELECTOR = `[data-cart-item-quantity]`

export class CartItem extends BaseComponent {
  mountComponent(): void {
    this.setHeight(this.hasAttribute('is-new') ? 0 : this.scrollHeight)
  }

  async removeItem(): Promise<void> {
    await this.collapse()
  }

  async expand(): Promise<void> {
    this.setHeight(this.scrollHeight)
    await transitionToPromise(this)
  }

  async collapse(): Promise<void> {
    this.setHeight(0)
    await transitionToPromise(this)
  }

  async showAsNew(): Promise<void> {
    await this.expand()
    this.removeAttribute('is-new')
  }

  showCheckmark = (): void => {
    const checkmark = $el(CHECKMARK_SELECTOR, this)

    checkmark?.classList.remove('hidden')
    delay(2500).then(() => {
      checkmark?.classList.add('hidden')
    })
  }

  setLoading = (isLoading: boolean): void => {
    const totals = $el(TOTALS_SELECTOR, this)
    totals?.toggleAttribute('is-loading', isLoading)
  }

  setHeight(maxHeight: number): void {
    this.style.maxHeight = `${Math.ceil(maxHeight)}px`
  }

  setDisabled(isDisable: boolean): void {
    const quantity: QuantityComponent = $el(QUANTITY_SELECTOR, this)
    quantity?.setDisable(isDisable)
  }
}
